import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';

export type Agreement = {
  id: string;
  name: string;
  createdAt: string;
  read: boolean;
  readAt?: string;
  readBy?: string;
};

export type PendingAgreement = Pick<Agreement, 'id' | 'name' | 'createdAt'>;

export class AgreementsApi extends ApiBase {
  model = 'foundation-agreements';

  public get(foundationId: string) {
    return this.http.get<Agreement[]>(
      this.buildUrl('by-foundation', foundationId),
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public getDownloadLink(id: string) {
    return this.http.get<{ downloadLink: string }>(
      this.buildUrl(id, 'download-link'),
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public acceptTerms(ids: string[]) {
    return this.http.post<{ accepted: number }>(this.buildUrl('accept'), ids, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public getPending() {
    return this.http.get<PendingAgreement[]>(
      this.buildUrl('pending-agreements'),
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }
}
